import { KeyDescription } from '@/enums/key_description';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { ENUM__grid2d_cell_size } from '@shared/dto/grid2d_cell/ENUM__grid2d_cell_size';
import { EShortcutGroup } from '@shared/dto/hint_shortcuts/e_shortcut_group';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { IHintShortcutData } from '@shared/dto/hint_shortcuts/i_hint_shortcut_data';
import { IHintKeyboardDataRow } from '@shared/dto/hint_shortcuts/i_hint_shortcut_data_row';
import { useTranslation } from 'react-i18next';
import { use_slice_user } from '../store/use_slices';
import { create_data_row } from './use_hints_shortcuts_data';

export function use_hint_shortcut_change_cells_size_with_scroll(): IHintShortcutData {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { user_settings } = use_slice_user(['user_settings']);

  let data_rows: IHintKeyboardDataRow[] = [];

  if (user_settings.ui_grid2d_cell_size != ENUM__grid2d_cell_size.XL) {
    data_rows = [
      ...data_rows,
      create_data_row(t(i18n_base_ui.shortcut_hints.grid2d.change_cell_size_with_scroll_increase), [KeyDescription.AltOrOption], { is_scroll_up: true }),
    ];
  }

  if (user_settings.ui_grid2d_cell_size != ENUM__grid2d_cell_size.XS) {
    data_rows = [
      ...data_rows,
      create_data_row(t(i18n_base_ui.shortcut_hints.grid2d.change_cell_size_with_scroll_decrease), [KeyDescription.AltOrOption], { is_scroll_down: true }),
    ];
  }

  return {
    data_rows,
    key: EShortcutType.FULLSCREEN_GRID2D_IMAGE_NAVIGATION_BY_SCROLL,
    keys_have_same_animation_delay: true,
    group: EShortcutGroup.GRID2D,
  };
}
